import Layout from '@/layouts/Layout'

const waitForRent = {
  path: '/car_to_lease',
  component: Layout,
  name: 'car_to_lease',
  meta: {
    title: '待租',
    icon: 'car_to_lease',
  },
  children: [
    {
      path: '/car_to_lease/groupDashboard/list',
      name: 'car_to_lease_data_board_tenant',
      component: () => import('@/pages/cars/waitLeaseDashboard/group/list'),
      meta: { title: '集团看板', logEvent: '' },
    },
    {
      path: '/car_to_lease/companyDashboard/list',
      name: 'car_to_lease_data_board_company',
      component: () => import('@/pages/cars/waitLeaseDashboard/company/list'),
      meta: { title: '公司看板', logEvent: '' },
    },
    {
      path: '/car_to_lease/forRentSignContract',
      name: 'for_rent_sign_contract',
      component: () => import('@/pages/orders/signContract/list'),
      meta: { title: '签约提车列表', logEvent: '' },
    },
    // 个人
    {
      path: '/car_to_lease/forRentSignContract/personalDetail',
      name: 'for_rent_sign_contract_rent_order_detail',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '个人租赁订单详情', logEvent: '' },
    },
    {
      path: '/car_to_lease/forRentSignContract/cancelContract',
      name: 'for_rent_sign_contract_rent_order_cancel_contract',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '退车解约',
        logEvent: '',
        parent: [
          {
            path: '/car_to_lease/forRentSignContract',
            name: 'for_rent_sign_contract',
            title: '签约提车列表',
          },
        ] },
    },
    {
      path: '/car_to_lease/forRentSignContract/personalSignContract',
      name: 'for_rent_sign_contract_rent_order_create',
      hidden: true,
      component: () => import('@/pages/orders/signContract/add/personalSignContract'),
      meta: { title: '个人签约提车',
        logEvent: '',
        parent: [
          {
            path: '/car_to_lease/forRentSignContract',
            name: 'for_rent_sign_contract',
            title: '签约提车列表',
          },
          {
            path: '/workbench/rentOrder/list',
            name: 'workbench_rent_order',
            title: '个人租赁订单',
          },
        ] },
    },
    // 企业(主)
    {
      path: '/car_to_lease/forRentSignContract/enterprisePrimaryDetail',
      name: 'for_rent_sign_contract_ent_rent_order_main_detail',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/enterprisePrimaryDetail'),
      meta: { title: '企业主订单详情', logEvent: '' },
    },
    {
      path: '/car_to_lease/forRentSignContract/entAddCar',
      name: 'for_rent_sign_contract_ent_rent_order_main_add_car',
      hidden: true,
      component: () => import('@/pages/orders/signContract/add/enterpriseAddOrder'),
      meta: { title: '新增租赁车辆', logEvent: '' },
    },
    {
      path: '/car_to_lease/forRentSignContract/createMasterOrder',
      name: 'for_rent_sign_contract_ent_rent_order_main_add',
      hidden: true,
      component: () => import('@/pages/orders/signContract/add/createMasterOrder'),
      meta: { title: '主订单创建流程', logEvent: '' },
    },
    // 企业(子)
    {
      path: '/car_to_lease/forRentSignContract/enterpriseChildDetail',
      name: 'for_rent_sign_contract_ent_rent_order_sub_detail',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '子订单详情', logEvent: '' },
    },
    {
      path: '/car_to_lease/forRentSignContract/subToOutStock',
      name: 'for_rent_sign_contract_ent_rent_order_sub_to_out_stock',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '发车验车',
        logEvent: '',
        parent: {
          path: '/car_to_lease/forRentSignContract',
          name: 'for_rent_sign_contract',
          title: '签约提车列表',
        } },
    },
    {
      path: '/car_to_lease/forRentSignContract/subFinanceDetail',
      name: 'for_rent_sign_contract_ent_rent_order_sub_finance_detail',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '订单支付',
        logEvent: '',
        parent: {
          path: '/car_to_lease/forRentSignContract',
          name: 'for_rent_sign_contract',
          title: '签约提车列表',
        } },
    },
    {
      path: '/car_to_lease/forRentSignContract/subCancelContract',
      name: 'for_rent_sign_contract_ent_rent_order_sub_cancel_contract',
      hidden: true,
      component: () => import('@/pages/orders/signContract/detail/personalDetail'),
      meta: { title: '退车解约',
        logEvent: '',
        parent: {
          path: '/car_to_lease/forRentSignContract',
          name: 'for_rent_sign_contract',
          title: '签约提车列表',
        } },
    },
    {
      path: '/car_to_lease/forRentSignContract/enterSiginProcess',
      name: 'for_rent_sign_contract_ent_rent_order_sub_add_car',
      hidden: true,
      component: () => import('@/pages/orders/signContract/add/enterSiginProcess'),
      meta: { title: '企业签约提车',
        logEvent: '',
        parent: [
          {
            path: '/car_to_lease/forRentSignContract',
            name: 'for_rent_sign_contract',
            title: '签约提车列表',
          },
          {
            path: '/workbench/entOrder/list',
            name: 'workbench_ent_rent_order',
            title: '企业租赁订单',
          },
        ] },
    },
    {
      path: '/car_to_lease/waitForRentCarList',
      name: 'car_to_lease_list',
      component: () => import('@/pages/orders/waitForRent/list/waitForRentCarList.vue'),
      meta: { title: '待租车辆列表', logEvent: '' },
    },
    {
      path: '/car_to_lease/leaseScheme/list',
      name: 'for_rent_config_ren_plan',
      component: () => import('@/pages/orders/leaseScheme/list/listTab'),
      meta: { title: '租赁方案管理', logEvent: '' },
    },
    {
      path: '/car_to_lease/vehicleManage/detail',
      name: 'car_to_lease_list_detail',
      // component: () => import('@/pages/carsManage/cars/carDetail'),
      component: () => import('@/pages/cars/vehicleManage/detail/index'),
      meta: { title: '车辆详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/car_to_lease/vehicleManage/edit',
      name: 'car_to_lease_list_edit',
      component: () => import('@/pages/cars/vehicleManage/add'),
      meta: { title: '编辑车辆',
        keepAlive: true,
        parent: {
          path: '/car_to_lease/waitForRentCarList',
          name: 'car_to_lease_list',
          title: '待租车辆列表',
        } },
      hidden: true,
    },
    {
      path: '/car_to_lease/maintenance/add',
      name: 'car_to_lease_list_maintain',
      component: () => import('@/pages/carsService/maintenance/add/index'),
      meta: { title: '新增维保管理',
        logEvent: '',
        parent: {
          path: '/car_to_lease/waitForRentCarList',
          name: 'car_to_lease_list',
          title: '待租车辆列表',
        } },
      hidden: true,
    },
    {
      path: '/car_to_lease/accident/add',
      name: 'car_to_lease_list_accident',
      component: () => import('@/pages/carsService/accident/add'),
      meta: { title: '新建事故',
        logEvent: '',
        parent: {
          path: '/car_to_lease/waitForRentCarList',
          name: 'car_to_lease_list',
          title: '待租车辆列表',
        } },
    },
    {
      path: '/car_to_lease/leaseScheme/detail',
      name: 'for_rent_config_ren_plan_detail',
      component: () => import('@/pages/orders/leaseScheme/detail/opened'),
      meta: { title: '租赁方案详情', logEvent: '' },
    },
    {
      path: '/car_to_lease/leaseScheme/edit',
      name: 'for_rent_config_ren_plan_edit',
      component: () => import('@/pages/orders/leaseScheme/edit'),
      meta: { title: '租赁方案编辑',
        logEvent: '',
        keepAlive: true,
        parent: {
          path: '/car_to_lease/leaseScheme/list',
          name: 'for_rent_config_ren_plan',
          title: '租赁方案管理',
        } },
    },
    {
      path: '/car_to_lease/leaseScheme/add',
      name: 'for_rent_config_ren_plan_create',
      component: () => import('@/pages/orders/leaseScheme/add'),
      meta: { title: '新增租赁方案',
        logEvent: '',
        keepAlive: false,
        parent: {
          path: '/car_to_lease/leaseScheme/list',
          name: 'for_rent_config_ren_plan',
          title: '租赁方案管理',
        } },
    },
    // 租赁商城
    {
      path: '/car_to_rent/commodity/list',
      name: 'car_to_rent_list',
      component: () => import('@/pages/shop/commodity/list'),
      meta: { title: '商品库' },
    },
    {
      path: '/car_to_rent/commodity/add',
      name: 'car_to_rent_scheme',
      component: () => import('@/pages/shop/commodity/add'),
      meta: { title: '新增商品',
        parent: {
          path: '/car_to_rent/commodity/list',
          name: 'car_to_rent_list',
          title: '商品库',
        } },
      hidden: true,
    },
    {
      path: '/car_to_rent/commodity/edit',
      name: 'car_to_rent_edit',
      component: () => import('@/pages/shop/commodity/add'),
      meta: { title: '编辑商品' },
      hidden: true,
    },
    {
      path: '/car_to_rent/commodity/detail',
      name: 'car_rent_scheme_detail',
      component: () => import('@/pages/shop/commodity/detail'),
      meta: { title: '商品详情' },
      hidden: true,
    },
    {
      path: '/car_to_lease/notSentCarList',
      name: 'for_rent_not_sent_car_info_list',
      component: () => import('@/pages/cars/list/cannotOutput.vue'),
      meta: { title: '不可发车辆列表', logEvent: '' },
    },
    {
      path: '/car_to_lease/salesLeadManagement',
      name: 'rent_car_clue_list',
      component: () => import('@/pages/orders/salesLeadManagement/list/index'),
      meta: { title: '销售线索管理', logEvent: '' },
    },
    // 新线索管理线索详情页
    {
      path: '/car_to_lease/salesClue/detail',
      // TODO:gc 上线更换对应的路由key
      name: 'rent_car_clue_sales_detail',
      component: () => import('@/pages/orders/salesLeadManagement/detail/index'),
      meta: { title: '详情', logEvent: '' },
      hidden: true,
    },
    // 旧销售线索管理线索详情页
    {
      path: '/car_to_lease/salesLeadManagement/detail',
      // TODO:gc 上线更换对应的路由key
      name: 'rent_car_clue_detail',
      component: () => import('@/pages/orders/salesLeadManagement/detail/index'),
      meta: { title: '详情', logEvent: '' },
      hidden: true,
    },
    // 新增 - 线索管理
    // 线索渠道 - 公司侧
    {
      path: '/car_to_lease/clueManagement/clueChannelsList',
      name: 'rent_car_clue_manage_channels',
      component: () => import('@/pages/orders/clueManagement/clueChannelsList'),
      meta: { title: '线索渠道', logEvent: '' },
    },
    // 销售线索 - 公司侧/集团侧
    {
      path: '/car_to_lease/clueManagement/salesClueList',
      name: 'rent_car_clue_manage_sales',
      component: () => import('@/pages/orders/salesLeadManagement/list/index'),
      meta: { title: '销售线索', logEvent: '' },
    },
  ],
}
export default waitForRent
